import React from 'react';
import { useCurations } from '../hooks/useCurations';
import { SupportedCurrency, getCurrencyFromLanguage } from '../utils/currencyUtils';
import { getCurrentLanguage } from '../config/languageConfig';
import CurationCard from './CurationCard';
import CurationSkeleton from './skeletons/CurationSkeleton';

const CurationSection: React.FC = () => {
  const { curations, loading } = useCurations();
  const currentLang = getCurrentLanguage();
  const currency: SupportedCurrency = getCurrencyFromLanguage(currentLang);

  // 로딩 중일 때 스켈레톤 표시
  if (loading) {
    return <CurationSkeleton />;
  }

  // 큐레이션이 없는 경우 섹션 자체를 숨김 (기존 로직 유지)
  if (curations.length === 0) {
    return null;
  }

  return (
    <div className="md-spacing-1">
      {/* 구분선 */}
      <div className="mx-4 mb-3 border-t border-gray-200"></div>
      
      {/* 큐레이션 카드들 */}
      <div>
        {curations.map((curation) => (
          <CurationCard 
            key={curation.category} 
            curation={curation} 
            currency={currency}
          />
        ))}
      </div>
    </div>
  );
};

export default CurationSection; 